/**
 * /board/$boardId/card/$cardId — Card detail slide-over.
 *
 * The route is nested under the board route so the board view stays
 * rendered behind the slide-over (deep-link still loads the board
 * underneath). The `?tab=` search param drives the active tab.
 */
import { createFileRoute, useParams } from '@tanstack/react-router';
import { z } from 'zod';

import { CardDetailSlideOver } from '../../../../../components/kanban/card-detail-slide-over';

const searchSchema = z
  .object({
    tab: z.enum(['chat', 'artifacts', 'audit', 'members', 'architect', 'settings']).optional(),
  })
  .strict();

function CardPage() {
  const { boardId, cardId } = useParams({ strict: false }) as {
    boardId: string;
    cardId: string;
  };
  // key={cardId} forces a clean remount when switching from one card to
  // another in the panel — inline title-edit state and tab focus don't
  // leak between cards. The route stays mounted (so the resize width is
  // preserved via localStorage in `useResizablePanel`).
  return <CardDetailSlideOver key={cardId} boardId={boardId} cardId={cardId} />;
}

export const Route = createFileRoute('/_authenticated/board/$boardId/card/$cardId')({
  component: CardPage,
  validateSearch: searchSchema.parse,
});
